import { langConfig } from "@/lang/langConfig";

export function addLangAtHtml (locale) {
    if(!locale) {
        return;
    }
    if(langConfig[locale]){
        let htmlTag = document.getElementsByTagName("html")[0]
        htmlTag && htmlTag.setAttribute('lang', langConfig[locale].extLang || '');
    }
}
